function matchesRootOrChild(pathname: string, routeRoot: string): boolean {
  return pathname === routeRoot || pathname.startsWith(`${routeRoot}/`);
}

const PRIVATE_VUOKRAUS_PREFIXES = [
  '/vuokraus/ilmoitukset',
  '/vuokraus/jonotus',
  '/vuokraus/muuttotarkastukset',
  '/vuokraus/lopputarkastukset',
  '/vuokraus/hakijat',
  '/vuokraus/sopimukset',
  '/vuokraus/valityssopimukset',
  '/vuokraus/laskut',
] as const;

/** Public anonymous rental pages (`/vuokraus/:token`, `/vuokraus/yhtio/:slug`), not the authenticated app. */
function isPublicVuokrausRoute(pathname: string): boolean {
  if (pathname === '/vuokraus') return false;
  if (!pathname.startsWith('/vuokraus/')) return false;
  return !PRIVATE_VUOKRAUS_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function isPublicUnauthedRoute(pathname: string): boolean {
  // These route trees intentionally work without the "main app" login session.
  // They authenticate via session tokens in query params/sessionStorage and must not
  // trigger `/users/current`, `/users/current/settings`, or `/users/refresh` attempts.
  return (
    pathname === '/tietosuojaseloste' ||
    pathname === '/muutosloki' ||
    pathname === '/ohjeet' ||
    pathname.startsWith('/ohjeet/') ||
    matchesRootOrChild(pathname, '/asukas') ||
    matchesRootOrChild(pathname, '/vuokranantaja') ||
    matchesRootOrChild(pathname, '/palvelupyynto') ||
    isPublicVuokrausRoute(pathname)
  );
}
